import script from "./Options.vue?vue&type=script&setup=true&lang=ts"
export * from "./Options.vue?vue&type=script&setup=true&lang=ts"

import "./Options.vue?vue&type=style&index=0&id=2f42396e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f42396e"]])

export default __exports__